
 
export class ManageLoginBannerColumns {



    public static fields = [
        {
            "fieldName": "bannerId",
            "headerText": "Id",
            "displayType": "text",
            "keyField": true,
            "colWidth": "cell-width-1"
        },
        {
            "fieldName": "fileName",
            "headerText": "Filename",
            "displayType": "text",
            "keyField": false,
            "colWidth": "cell-width-60"
        },
        {
            "fieldName": "createdOn",
            "headerText": "Created On",
            "displayType": "text",
            "keyField": false,
            "colWidth": ""
        },
        {
            "fieldName": "createdBy",
            "headerText": "Created By",
            "displayType": "text",
            "keyField": false,
            "colWidth": ""
        },

    ]

}
